import React, { useState, useEffect } from "react";
import "./App.css";
import Borsa from "./porsa/Borsa";
import SimpleAdmin from "./admin/SimpleAdmin";

// إصدار التطبيق
const APP_VERSION = "4.2.0";

// مكون تثبيت PWA
const InstallPWA = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setSupportsPWA(true);
      setPromptInstall(e);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) {
      return;
    }
    promptInstall.prompt();
  };

  if (!supportsPWA) {
    return null;
  }

  return (
    <div className="install-banner">
      <div className="install-content">
        <span> 📱تثبيت التطبيق على هاتفك </span>{" "}
        <button className="install-btn" onClick={onClick}>
          تثبيت التطبيق{" "}
        </button>{" "}
      </div>{" "}
    </div>
  );
};

// مكون التحديث
const UpdateNotifier = () => {
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    const savedVersion = localStorage.getItem("app_version");
    if (savedVersion !== APP_VERSION) {
      setShowUpdate(true);
    }
  }, []);

  const handleUpdate = () => {
    localStorage.setItem("app_version", APP_VERSION);
    window.location.reload();
  };

  const handleClose = () => {
    localStorage.setItem("app_version", APP_VERSION);
    setShowUpdate(false);
  };

  if (!showUpdate) return null;

  return (
    <div className="update-banner">
      <div className="update-content">
        <div className="update-text">
          <span className="update-title"> 🔄تحديث جديد متاح! </span>{" "}
          <span className="update-message"> يحتوي على أحدث البيانات </span>{" "}
        </div>{" "}
        <div className="update-actions">
          <button className="update-btn" onClick={handleUpdate}>
            تحديث الآن{" "}
          </button>{" "}
          <button className="update-close" onClick={handleClose}>
            إغلاق{" "}
          </button>{" "}
        </div>{" "}
      </div>{" "}
    </div>
  );
};

function App() {
  const [currentView, setCurrentView] = useState("main");

  // التحقق من الرابط عند التحميل
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("admin") === "true") {
      setCurrentView("admin");
    }

    // تهيئة الإصدار
    const currentVersion = localStorage.getItem("app_version");
    if (!currentVersion) {
      localStorage.setItem("app_version", APP_VERSION);
    }
  }, []);

  // عرض صفحة الإدارة
  if (currentView === "admin") {
    return <SimpleAdmin />;
  }

  // عرض الصفحة الرئيسية
  return (
    <div className="App">
      <InstallPWA />
      <UpdateNotifier />
      <Borsa />
    </div>
  );
}

export default App;
